import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import { useIsEmbedded } from 'hooks/useIsEmbedded';
import PropTypes from 'prop-types';

import GoToManagePlanPageButton from 'features/managePlan/components/GoToManagePlanPageButton';

import ModalCloseIcon from 'components/modals/ModalCloseIcon';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';
import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

const { cx } = cxHelpers('ManagerNotesPaywall');

const LIST_STYLE = { listStyle: 'disc' };
const LIST_ITEM_STYLE = { marginBottom: '6px' };

const ManagerNotesPaywall = ({
  setShowManagerNotePaywall,
  showModalClose,
  showImage,
  tierName,
  trackUpgradeClicked,
}) => {
  const isEmbedded = useIsEmbedded();

  function handleClickUpgrade() {
    trackUxEvent({
      productArea: PRODUCT_AREAS.TIMESHEETS,
      eventCategory: EVENT_CATEGORIES.TIMECARD_DETAIL,
      eventAction: EVENT_ACTIONS.UPGRADE_BUTTON_FROM_NOTES_PAYWALL_CLICKED_V3,
    });
  }

  return (
    <Box column w="100%" className={cx()}>
      {showModalClose && (
        <Box absolute top={14} right={16}>
          <ModalCloseIcon onClick={setShowManagerNotePaywall(false)} />
        </Box>
      )}
      {showImage && (
        <Box mt={20} vcenter minh={102}>
          <img src={require('./loading-basic.png')} alt="loading" height={37} />
        </Box>
      )}
      <Box>
        <Box mb={12}>
          <Text
            variant="heading4"
            color="mono900"
            i18n="timecard_modal.manager_notes.paywall.title"
          />
        </Box>
        <Box ml={28}>
          <ul style={LIST_STYLE}>
            {toI18n('timecard_modal.manager_notes.paywall.description').map(
              (item, key) => (
                <li style={LIST_ITEM_STYLE} key={key}>
                  <Text>{item}</Text>
                </li>
              )
            )}
          </ul>
        </Box>
        <Box pv={24}>
          <GoToManagePlanPageButton
            fullWidth
            loadFullPage
            size="large"
            theme={isEmbedded ? 'clover-green' : 'primary-purple'}
            i18nProps={{ tier: tierName }}
            i18n={
              isEmbedded
                ? 'manage_plans.title'
                : 'timecard_modal.manager_notes.paywall.button'
            }
            onClick={trackUpgradeClicked && handleClickUpgrade}
          />
        </Box>
      </Box>
    </Box>
  );
};

ManagerNotesPaywall.propTypes = {
  setShowManagerNotePaywall: PropTypes.func,
  showModalClose: PropTypes.bool,
  showImage: PropTypes.bool,
  tierName: PropTypes.string.isRequired,
  trackUpgradeClicked: PropTypes.bool,
};

export default ManagerNotesPaywall;
